import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { HttpMethodService } from '../services/http-method.service';
import { ControlsService } from '../services/controls.service';

@Injectable()
export class AuthGuard implements CanActivate {

  returnUrl: string;
  constructor(private router: Router,
              private autentication: AuthenticationService,
              private methodService: HttpMethodService,
              private controlService: ControlsService,
              private route: ActivatedRoute) {
              this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
  }

  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

  //     console.log({url: (next as any)._routerState.url})
  //   let menu = localStorage.getItem('menuCC');
  //   let url = (next as any)._routerState.url
  //   console.log({menu})
  //   if (localStorage.getItem('isLoggedinCC') === 'true') {
  //     if (menu && menu.includes(url) || ((url.includes('reportes/votos-reportados') || url.includes('reportes/ver-votantes/')) && menu.includes('reportes/')) || url == '/inicio') {
  //       return true;
  //     } else {
  //       this.router.navigate(['/inicio']);
  //       this.controlService.msgInfo('Usted no tiene acceso a la pagina solicitada.');
  //       return false;
  //     }
  //   }

  //   this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
  //   return false;
  // }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (localStorage.getItem('isLoggedinCF') === 'true') {
      // this.router.navigate([this.returnUrl]);
      return true;
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
    return false;
  }
 
}
